<div class="enhancedPopup">
  <!-- Page: Intro -->
  <swiper-container class="swiper" #enhancedModelSwiper id="enhancedModelSwiper" *ngIf="currentPage === 'Intro'"
    init="false">
    <!-- 1st slide -->
    <swiper-slide swiperSlide data-swiper-animation="animate__fadeIn" data-duration=".5s" data-delay="1s"
      data-swiper-out-animation="animate__fadeOut" data-out-duration=".2s" class="enhancedSlide" *ngIf="showAllSlides">
      <ion-icon class="enhancedCloseBtn" (click)="dismiss()" name="close-outline"
        data-cy="enhancedModal-firstSlide-dismiss"></ion-icon>

      <div class="enhancedSlideWrap">
        <div *ngIf="listing" class="enhancedSlideSubheader" data-cy="enhancedModal-firstSlide-title">
          Why Pair A Lender?
        </div>
        <div *ngIf="listing" class="enhancedSlideBody" data-cy="enhancedModal-firstSlide-dscr">
          The paired lender is a well qualified mortgage pro. They're available
          to help leads who indicate they have mortgage questions.
        </div>

        <div *ngIf="!listing" class="enhancedSlideSubheader" data-cy="enhancedModal-firstSlide-title">
          What is a default lender?
        </div>
        <div *ngIf="!listing" class="enhancedSlideBody" data-cy="enhancedModal-firstSlide-dscr">
          The default lender is a well qualified mortgage pro. They're available
          to help leads who indicate they have mortgage questions.
        </div>

        <div class="kioskLoanWrapper link" (click)="openLoanOfficerWebsite()">
          <div class="loanOfficerImgDiv">
            <div class="loanOfficerImg" [style.backgroundImage]="'url(' + (loanOfficer.image)  + ')' | safe: 'style'"
              data-cy="enhancedModal-firstSlide-kiosk-img"></div>
          </div>

          <div class="leftAlign">
            <div class="bold" data-cy="enhancedModal-firstSlide-kiosk-name">
              {{loanOfficer.name}}
            </div>
            <div data-cy="enhancedModal-firstSlide-kiosk-company">
              {{loanOfficer.company}}
            </div>

            <div class="pad-top-5" *ngFor="let item of loanOfficerReviews">
              <div class="kioskLoanOfficerReview" *ngIf="item.review.enabled">
                <img class="reviewLogo" [src]="item.review.reviewLogo | safe: 'url'"
                  data-cy="enhancedModal-firstSlide-kiosk-review-logo" />

                <span class="reviewScore"
                  data-cy="enhancedModal-firstSlide-kiosk-review-score">{{item.review.reviewStars | number:'1.1'
                  }}</span>
                <div class="reviewRatingSection">
                  <ionic-rating-component activeIcon="star" defaultIcon="star-outline" activeColor="#FFBB54"
                    defaultColor="#C1C8D7" rating="{{item.review.reviewStars}}" readonly="true" fontSize="18px"
                    data-cy="enhancedModal-firstSlide-kiosk-review-rating">
                  </ionic-rating-component>
                </div>
                <div class="font-12 reviewCount" data-cy="enhancedModal-firstSlide-kiosk-review-count">
                  ({{item.review.reviewCount}})
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="push-down enhancedSlideBody bold link margin-left-5" (click)="openExternalLink(1)"
          data-cy="enhancedModal-firstSlide-learnMoreBtn">
          Learn more about the standards that our {{ listing ? 'expert' : 'default' }} lenders must meet
        </div>

        <div class="slideFooter">
          <div *ngIf="listing">
            <ion-button fill="outline" (click)="invite('lender')" ion-button outline
              data-cy="enhancedModal-firstSlide-inviteLenderBtn">PAIR MY OWN LENDER</ion-button>
            <ion-button fill="outline" (click)="disableLender()" ion-button outline
              data-cy="enhancedModal-firstSlide-disablePairedLenderBtn">DISABLE PAIRED LENDER</ion-button>
          </div>
        </div>
      </div>
    </swiper-slide>

    <!-- 2nd slide -->
    <swiper-slide swiperSlide data-swiper-animation="animate__fadeIn" data-duration=".5s" data-delay="1s"
      data-swiper-out-animation="animate__fadeOut" data-out-duration=".2s" class="enhancedSlide"
      style="background-color: #142955" *ngIf="showAllSlides">
      <ion-icon class="enhancedCloseBtn" (click)="dismiss()" name="close-outline"
        data-cy="enhancedModal-secondSlide-dismiss"></ion-icon>

      <div class="enhancedSlideWrap">
        <div *ngIf="listing" class="enhancedSlideSubheader" data-cy="enhancedModal-secondSlide-title">
          Why Pair A Lender?
        </div>
        <div *ngIf="listing" class="enhancedSlideBody" data-cy="enhancedModal-secondSlide-dscr">
          Exceptional reviews from dozens of clients
        </div>

        <div *ngIf="!listing" class="enhancedSlideSubheader" data-cy="enhancedModal-secondSlide-title">
          What is a default lender?
        </div>
        <div *ngIf="!listing" class="enhancedSlideBody" data-cy="enhancedModal-secondSlide-dscr">
          Exceptional reviews from dozens of clients
        </div>

        <div class="push-down secondSlideBodyDiv">
          <div class="loanOfficerWrapper link" (click)="openLoanOfficerWebsite()">
            <div class="loanOfficerImgDiv">
              <div class="loanOfficerImg" [style.backgroundImage]="'url(' + (loanOfficer.image)  + ')' | safe: 'style'"
                data-cy="enhancedModal-secondSlide-kiosk-img"></div>
            </div>
            <div class="loanOfficerSection">
              <div class="pad-5 subTitle bold font-20" data-cy="enhancedModal-secondSlide-kiosk-name">
                {{loanOfficer.name}}
              </div>
              <div class="pad-5 enhanced-address" data-cy="enhancedModal-secondSlide-kiosk-company">
                {{loanOfficer.company}}
              </div>
            </div>
          </div>
          <div class="reviewsWrapDiv">
            <div *ngFor="let item of loanOfficerReviews">
              <div class="loanOfficerReview" *ngIf="item.review.enabled">
                <img class="reviewLogo" [src]="item.review.reviewLogo | safe: 'url'"
                  data-cy="enhancedModal-secondSlide-kiosk-review-logo" />

                <div class="reviewRatingSection">
                  <ionic-rating-component activeIcon="star" defaultIcon="star-outline" activeColor="#FFBB54"
                    defaultColor="#C1C8D7" rating="{{item.review.reviewStars}}" readonly="true" fontSize="18px"
                    data-cy="enhancedModal-secondSlide-kiosk-review-score">
                  </ionic-rating-component>

                  <div class="bold font-12 reviewCount" data-cy="enhancedModal-secondSlide-kiosk-review-count">
                    {{item.review.reviewCount}} Reviews
                  </div>
                </div>

                <div class="font-12 reviewComment" data-cy="enhancedModal-secondSlide-kiosk-review-rating">
                  {{item.review.reviewSnippet}}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="slideFooter">
          <div *ngIf="listing">
            <ion-button fill="outline" (click)="invite('lender')" ion-button outline
              data-cy="enhancedModal-secondSlide-inviteLenderBtn">PAIR MY OWN LENDER</ion-button>
            <ion-button fill="outline" (click)="disableLender()" ion-button outline
              data-cy="enhancedModal-secondSlide-disablePairedLenderBtn">DISABLE PAIRED LENDER</ion-button>
          </div>
        </div>
      </div>
    </swiper-slide>

    <!-- 3rd slide -->
    <swiper-slide swiperSlide data-swiper-animation="animate__fadeIn" data-duration=".5s" data-delay="1s"
      data-swiper-out-animation="animate__fadeOut" data-out-duration=".2s" class="enhancedSlide">
      <ion-icon class="enhancedCloseBtn" (click)="dismiss()" name="close-outline"
        data-cy="enhancedModal-thirdSlide-dismiss"></ion-icon>

      <div class="enhancedSlideWrap">
        <!-- <div class="enhancedSlideHeader"></div> -->
        <div *ngIf="listing" class="enhancedSlideSubheader" data-cy="enhancedModal-thirdSlide-title">
          Why Pair A Lender?
        </div>

        <div *ngIf="listing" class="enhancedSlideBody" data-cy="enhancedModal-thirdSlide-dscr">
          Paired lenders cover the cost of the following features that agents
          can use at no cost:
        </div>

        <div *ngIf="!listing" class="enhancedSlideSubheader" data-cy="enhancedModal-thirdSlide-title">
          What is a default lender?
        </div>

        <div *ngIf="!listing" class="enhancedSlideBody" data-cy="enhancedModal-thirdSlide-dscr">
          Default lenders cover the cost of the following features that agents
          can use at no cost:
        </div>

        <ul data-cy="enhancedModal-thirdSlide-list">
          <li>Lead verification & background info</li>
          <li>Property microsites</li>
          <li>Touchless sign-in via QR Code</li>
          <li>Easier note capture for leads</li>
          <li>Text follow up for guests</li>
        </ul>
        <div class="push-down enhancedSlideBody bold link" (click)="openExternalLink(2)"
          data-cy="enhancedModal-thirdSlide-learnMoreBtn">
          Tell Me More About These Features
        </div>

        <div class="slideFooter">
          <div *ngIf="listing">
            <ion-button fill="outline" *ngIf="!loanOfficer" (click)="invite('lender')" ion-button outline>PAIR MY OWN
              LENDER</ion-button>
            <ion-button fill="outline" (click)="disableLender()" ion-button outline
              data-cy="enhancedModal-thirdSlide-disablePairedLenderBtn">DISABLE PAIRED LENDER ON THIS
              LISTING</ion-button>
          </div>
        </div>
      </div>
    </swiper-slide>
  </swiper-container>

  <!-- Page: Disable prefered lender -->
  <div *ngIf="currentPage === 'DisableLender'" class="enhancedSlide full-height">
    <ion-icon class="enhancedCloseBtn" (click)="dismiss()" name="close-outline"
      data-cy="enhancedModal-disablePairedLender-dismiss"></ion-icon>

    <div class="enhancedSlideWrap">
      <div class="enhancedSlideSubheader" data-cy="enhancedModal-disablePairedLender-title">
        Disable Paired Lender
      </div>

      <div class="enhancedSlideBody">
        Disabling the paired lender will also disable the following features:
      </div>

      <ul class="margin-top-10" data-cy="enhancedModal-disablePairedLender-dscr">
        <li>Lead verification & background info</li>
        <li>Property microsites</li>
        <li>Touchless sign-in via QR Code</li>
        <li>Easier note capture for leads</li>
        <li>Text follow up for guests</li>
      </ul>
      <div class="push-down enhancedSlideBody bold link" (click)="openExternalLink(2)"
        data-cy="enhancedModal-disablePairedLender-learnMoreBtn">
        Tell Me More About These Features
      </div>

      <div class="slideFooter">
        <div *ngIf="listing">
          <ion-button fill="outline" style="width: 210px" (click)="changeEnhancedMode(false)" ion-button outline
            data-cy="enhancedModal-disablePairedLender-disableBtn">DISABLE
          </ion-button>
          <ion-button fill="outline" style="width: 210px" (click)="dismiss()" ion-button outline>KEEP THESE
            FEATURES</ion-button>
        </div>
      </div>
    </div>
  </div>

  <!-- Page: Disable regional lender -->
  <div *ngIf="currentPage === 'DisableRegionalLender'" class="enhancedSlide full-height">
    <ion-icon class="enhancedCloseBtn" (click)="dismiss()" name="close-outline"
      data-cy="enhancedModal-disablePairedLender-dismiss"></ion-icon>

    <div class="enhancedSlideWrap flex-body">
      <div class="enhancedSlideSubheader" data-cy="enhancedModal-disablePairedLender-title">
        Options to Disable Lender
      </div>

      <div class="enhancedSlideBody options-buttons">
        <button (click)="goTo('DisableLender')" class="disable-lender-options" fill="outline">
          <ion-icon class="disable-option-icon" name="close-circle-outline"></ion-icon>
          <div class="disable-option-text">Disable lender and lose Enhanced Features</div>
        </button>
        <button (click)="invite('agentAdmin')" class="disable-lender-options" fill="outline">
          <ion-icon class="disable-option-icon" name="bag-add-outline"></ion-icon>
          <div class="disable-option-text">
            See if your team/brokerage has an eligible plan to disable lender and <b>keep Enhanced Features</b>
          </div>
        </button>
      </div>

      <div class="enhancedSlideBody link underline" (click)="openExternalLink(2)"
        data-cy="enhancedModal-disablePairedLender-learnMoreBtn">
        See Enhanced Features
        <ion-icon class="enhanced-features-arrow" name="arrow-forward-outline"></ion-icon>
      </div>
    </div>
  </div>

  <!-- Page: Invite lender / admin -->
  <div *ngIf="currentPage === 'Invite'" class="enhancedSlide">
    <ion-icon class="enhancedCloseBtn" (click)="dismiss()" name="close-outline"
      data-cy="enhancedModal-inviteLender-dismiss"></ion-icon>

    <div class="enhancedSlideWrap">
      <div class="enhancedSlideSubheader" data-cy="enhancedModal-inviteLender-title">
        {{
        roleToInvite === 'lender'
        ? "Invite Your Lender"
        : "Who's your Team/Broker Admin?"
        }}
      </div>

      <div class="enhancedSlideBody" data-cy="enhancedModal-inviteLender-dscr">
        {{
        roleToInvite === 'lender'
        ? "What's a good email for your lender?' We'll invite them to sign up with Curb Hero"
        : "What's a good email for your Team / Broker Admin? If they don't have an active plan, we'll invite them to sign up with Curb Hero"
        }}
      </div>

      <algolia-search-with-invite
        class="search-with-invite"
        [listing]="listing"
        [theme]="'blue'"
        [instanceName]="instanceName"
        [roleOfUserToInvite]="roleToInvite"
        [noResultsMessage]="noResultsMessage"
        (onSucessfullEmailSent)="onEmailSent()"
      />
    </div>
  </div>

  <!-- Page: Enable lender -->
  <div *ngIf="currentPage === 'EnableLender'" class="enhancedSlide">
    <ion-icon class="enhancedCloseBtn" (click)="dismiss()" name="close-outline"
      data-cy="enhancedModal-enablePairedLender-dismiss"></ion-icon>

    <div class="enhancedSlideWrap">
      <div class="enhancedSlideSubheader" data-cy="enhancedModal-enablePairedLender-title">
        Why Pair A Lender?
      </div>
      <div class="enhancedSlideBody">
        Enabling a paired lender enables the following features:
      </div>

      <ul class="margin-top-10" data-cy="enhancedModal-enablePairedLender-dscr">
        <li>Lead verification & background info</li>
        <li>Property microsites</li>
        <li>Touchless sign-in via QR Code</li>
        <li>Easier note capture for leads</li>
        <li>Text follow up for guests</li>
      </ul>

      <div class="push-down enhancedSlideBody bold link" (click)="openExternalLink(2)"
        data-cy="enhancedModal-enablePairedLender-learnMoreBtn">
        Tell Me More About These Features
      </div>

      <div class="slideFooter">
        <div *ngIf="listing">
          <ion-button fill="outline" style="width: 210px" (click)="changeEnhancedMode(true)" ion-button outline
            data-cy="enhancedModal-enablePairedLender-enableBtn">ENABLE
          </ion-button>
          <ion-button fill="outline" style="width: 210px" (click)="dismiss()" ion-button outline
            data-cy="enhancedModal-enablePairedLender-noThanksBtn">NO THANKS</ion-button>
        </div>
      </div>
    </div>
  </div>

  <!-- Page: Thank you -->
  <div *ngIf="currentPage === 'ThankYouPage'" class="enhancedSlide">
    <ion-icon class="enhancedCloseBtn" (click)="dismiss()" name="close-outline"></ion-icon>

    <div class="enhancedSlideWrap">
      <div class="enhancedSlideSubheader">Thank You!</div>

      <div class="enhancedSlideBody">
        {{
        roleToInvite === 'lender'
        ? "We will send them an invite to pair with you. If they don't have an account already, they can sign up at app.curbhe.ro. If you or your lender have any questions about pairing please email"
        : "We will send them info on creating / updating their account so you can disable the paired lender and keep all features. If you or your team / broker have any questions about pairing please email"
        }}
        <a class="cleanText" href="mailto:support@curbhe.ro?Subject=Support" target="_top">support&#64;curbhe.ro</a>
      </div>
    </div>
  </div>
</div>